import './OceanBackground.css';

/**
 * PATRiK — статичный фон-фото (маяк). Fixed, за контентом, не перехватывает клики.
 * Сверху — тёмная вуаль для читаемости карточек.
 */
export const OceanBackground = () => (
  <div className="ocean" aria-hidden="true">
    <div className="ocean-photo" />
    <div className="ocean-veil" />
  </div>
);
